// import ArrowIcon from '@library/assets/images/icons/arrow-right.svg';
// import { Button } from '@library/components/buttons';
// import type { FormattedChannel } from '@library/types/alerts';
// import { Input } from '@library/components/inputs';
// import { Spinner } from '@library/components/Spinner';
// import { useChannels } from '@bo-hooks/alerts/useChannels';
// import { useState } from 'react';

import { PaginationButtons } from '@library/components/buttons/PaginationButtons';

export interface CreateAlertInputProps {
  page: number;
  setPage: (page: number) => void;
  totalPages: number;
}

export const CreateAlertInput = ({
  page,
  setPage,
  totalPages
}: CreateAlertInputProps) => {
  // const { handleCreateAlert } = useChannels({});
  // const [alertText, setAlertText] = useState('');
  // const [alertSent, setAlertSent] = useState(false);

  // const areNotificationsVisibleummary =
  //   channel?.displayName.toLocaleLowerCase() === 'notifications';

  return (
    <div className="bg-soFresh-110 flex w-full justify-end px-4">
      <PaginationButtons
        currentPage={page}
        handlePageChange={setPage}
        totalPages={totalPages ?? 0}
      />
      {/* <div className="bg-soFresh-120 border-soFresh-140 relative mb-6 flex h-10 w-11/12 rounded-md border">
        <Input
          className="text-soClean-100 size-full rounded-md border-none bg-transparent py-4 sm:text-sm"
          onValueChange={(value) => setAlertText(value)}
          placeholder="Send an alert"
          value={alertText ?? ''}
          disabled={areNotificationsVisibleummary}
        />
        <Button
          disabled={areNotificationsVisibleummary || alertSent || !alertText}
          onClick={() =>
            handleCreateAlert(alertText, setAlertSent, setAlertText)
          }
        >
          {alertSent ? (
            <Spinner className="absolute right-3 top-3 size-4" />
          ) : (
            <img
              alt="Create and send alert"
              className="absolute right-3 top-3 size-4"
              title="send alert"
              src={ArrowIcon}
            />
          )}
        </Button>
      </div> */}
    </div>
  );
};
